
export enum ModuleExecutorSuccessfulCd {
	FAILURE = 'Failure',
	SUCCESSFUL = 'Successful'}

